import api from "apis/employeeRoleCourse";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";

// payload is { courseId, employeeRoleId }
export const addCourseRole = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: payload,
  endpoint: api.addCourseRole(),
  successCallback,
  mountedRef,
});

export const deleteCourseRole = (courseId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.deleteCourseRole(courseId),
  successCallback,
  mountedRef,
});

export const getRolesForCourse = (courseId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getRolesForCourse(courseId),
  successCallback,
  mountedRef,
});
